<div>
    <!-- <h2>UAV Details</h2> -->
    <asset-basic-info [asset]="asset"></asset-basic-info>
    <asset-premiums [asset]="asset" (validated)="onPremiumsValidated($event)"></asset-premiums>
    <asset-endorsements [asset]="asset" (validated)="onEndorsementsValidated($event)"></asset-endorsements>
</div>
